/**
 * 指導計画/帳票
 */

export const GuidancePlanTypeItems = [
  { text: "General Plan", value: "general" },
  { text: "Yearly Guidance Plan", value: "yearly" },
  { text: "Monthly Guidance Plan", value: "monthly" },
  { text: "Weekly Guidance Plan", value: "weekly" },
];

export const GuidancePlanFormItemCategoryItems = [
  { text: "Heading", value: "heading" },
  { text: "Text", value: "text" },
  { text: "Date", value: "date" },
  { text: "Per-Child Text", value: "childText" },
  { text: "Grid", value: "grid" },
];
